const orderOriginOptions = [
  {
    filterId: '',
    title: 'E-commerce e lojas físicas',
  },
  {
    filterId: 'ecommerce',
    title: 'E-commerce',
  },
  {
    filterId: 'physical_stores',
    title: 'Lojas físicas',
  },
];
const orderOriginGroupOptions = {
  EcommerceAndPhysicalStores: orderOriginOptions[0],
  Ecommerce: orderOriginOptions[1],
  PhysicalStores: orderOriginOptions[2],
}

const fulfillmentOptions = [
  {
    filterId: 'mystore_and_ecommerce',
    title: 'Minha loja e E-commerce',
  },
  {
    filterId: '',
    title: 'Minha loja',
  },
  {
    filterId: 'ecommerce',
    title: 'E-commerce'
  },
];
const fulfillmentGroupOptions = {
  MyStoreAndEcommerce: fulfillmentOptions[0],
  MyStore: fulfillmentOptions[1],
  Ecommerce: fulfillmentOptions[2],
}

export const omnichannelResources = {
  FulfillmentGroupOptions: fulfillmentGroupOptions,
  FulfillmentOptions: fulfillmentOptions,
  OrderOriginGroupOptions: orderOriginGroupOptions,
  OrderOriginOptions: orderOriginOptions,
};